import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';



import { WelcomeComponent } from './welcome/welcome.component';
import { ChisiamoComponent } from './chisiamo/chisiamo.component';

// AREE TEMATICHE
import { MiinteressaComponent } from './miinteressa/miinteressa.component';
import { AcqueComponent } from './miinteressa/acque/acque.component';
import { AgentifisiciComponent } from './miinteressa/agentifisici/agentifisici.component';
import { AriaComponent } from './miinteressa/aria/aria.component';
import { ConservazionenaturaComponent } from './miinteressa/conservazionenatura/conservazionenatura.component';
import { EnergiaComponent } from './miinteressa/energia/energia.component';
import { RifiutiComponent } from './miinteressa/rifiuti/rifiuti.component';
import { TerritorioComponent } from './miinteressa/territorio/territorio.component';

// IO SONO
import { IosonoComponent } from './iosono/iosono.component';
import { CittadinoComponent } from './iosono/cittadino/cittadino.component';
import { ImpresaprofessionistaComponent } from './iosono/impresaprofessionista/impresaprofessionista.component';
import { OperatoreComponent } from './iosono/operatore/operatore.component';
import { DelegatoComponent } from './iosono/delegato/delegato.component';

// SERVIZI ONLINE
import { ServizionlineComponent } from './servizionline/servizionline.component';
import { CartografiaComponent } from './servizionline/cartografia/cartografia.component';
import { IndicatoriambientaliComponent } from './servizionline/indicatoriambientali/indicatoriambientali.component';
import { GestioneprocedimentiamministrativiComponent } from './servizionline/gestioneprocedimentiamministrativi/gestioneprocedimentiamministrativi.component';
import { MonitoraggiambientaliComponent } from './servizionline/monitoraggiambientali/monitoraggiambientali.component';
import { GeoportaleComponent } from './servizionline/geoportale/geoportale.component';

import { NewsComponent } from './news/news.component';

// DATI APERTI
import { DatiapertiComponent } from './datiaperti/datiaperti.component';
import { ElenchiComponent } from './datiaperti/elenchi/elenchi.component';
import { NormativaComponent } from './datiaperti/normativa/normativa.component';
import { DatiCartograficiComponent } from './datiaperti/daticartografici/daticartografici.component';

import { MappaportaleComponent } from './mappaportale/mappaportale.component';


import { ContattaciComponent } from './contattaci/contattaci.component';
import { NotelegaliComponent } from './notelegali/notelegali.component';
import { CookiesComponent } from './cookies/cookies.component';
import { PrivacyComponent } from './privacy/privacy.component';

import { HomeprivataComponent } from './homeprivata/homeprivata.component';
import { AuthGuard } from './auth/auth.service';
import { IframecontainerComponent } from './iframecontainer/iframecontainer.component';
import { HelpdeskComponent } from './helpdesk/helpdesk.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: HomeprivataComponent
  },
  {
//    path: 'viewcomp/:url',
    path: 'viewcomp',
    component: IframecontainerComponent
  },
  {path: 'welcome', component: WelcomeComponent },
  {path: 'chisiamo', component: ChisiamoComponent },
  {path: 'miinteressa', component: MiinteressaComponent },
  {path: 'acque', component: AcqueComponent },
  {path: 'agentifisici', component: AgentifisiciComponent },
  {path: 'aria', component: AriaComponent },
  {path: 'conservazionenatura', component: ConservazionenaturaComponent },
  {path: 'energia', component: EnergiaComponent },
  {path: 'rifiuti', component: RifiutiComponent },
  {path: 'territorio', component: TerritorioComponent },
  {path: 'iosono', component: IosonoComponent },
  {path: 'cittadino', component: CittadinoComponent },
  {path: 'impresaprofessionista', component: ImpresaprofessionistaComponent },
  {path: 'operatore', component: OperatoreComponent },
  {path: 'delegato', component: DelegatoComponent },
  {path: 'servizionline', component: ServizionlineComponent },
  {path: 'cartografia', component: CartografiaComponent },
  {path: 'indicatoriambientali', component: IndicatoriambientaliComponent },
  {path: 'gestioneprocedimentiamministrativi', component: GestioneprocedimentiamministrativiComponent },
  {path: 'monitoraggiambientali', component: MonitoraggiambientaliComponent },
  {path: 'daticartografici', component: DatiCartograficiComponent },
  {path: 'elenchi', component: ElenchiComponent },
  {path: 'normativa', component: NormativaComponent },
  {path: 'geoportale', component: GeoportaleComponent },
  {path: 'news', component: NewsComponent },
  {path: 'datiaperti', component: DatiapertiComponent },
  {path: 'mappaportale', component: MappaportaleComponent },
  {path: 'contattaci', component: ContattaciComponent },
  {path: 'notelegali', component: NotelegaliComponent },
  {path: 'cookies', component: CookiesComponent },
  {path: 'privacy', component: PrivacyComponent },
  {path: 'helpdesk', component: HelpdeskComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRouters {}